import React from "react";
import styled from "@emotion/styled";
import { Grid, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import theme from "theme";

const Container = styled(Grid)`
	border: 1px solid ${theme.palette.neutral.medium};
	border-radius: 15px;
	padding: 10px;
	background-color: white;
	transform: scale(1);
	transform-origin: center center;
	will-change: transform;
	transition: transform 0.2s ease, box-shadow 0.2s ease;
	${(props) =>
		props.hasSection &&
		`
		cursor: pointer;
		&:hover {
			box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
			transform: scale(1.02);
		}
	`}
`;

const StyledImage = styled.img`
	padding-right: 10px;
`;

const Title = styled(Typography)`
	font-weight: bold;
	font-size: 20px;
`;

const Description = styled(Typography)`
	font-size: 12px;
`;

const Roles = styled(Typography)`
	font-size: 12px;
	font-weight: bold;
`;

const Chevron = styled(ChevronRightIcon)`
	color: ${theme.palette.neutral.main};
	margin-left: 8px;
`;

const formatRoles = (roles) => {
	return roles.join(" · ");
};

const InfoColumn = ({ project }) => {
	return (
		<Grid container direction='column'>
			<Grid item>
				<Title variant='h3'>
					{project.name} · {project.shortTimeFrame}
				</Title>
			</Grid>
			<Grid item>
				<Description>{project.shortDescription}</Description>
			</Grid>
			<Grid item>
				<Roles>{formatRoles(project.roles)}</Roles>
			</Grid>
		</Grid>
	);
};

const BrowseSectionBlock = ({ project, targetRef }) => {
	const hasSection = !!project.sectionId;

	const scrollToItem = () => {
		if (targetRef && targetRef.current) {
			targetRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<Grid item md={6} xs={12} sx={{ paddingX: 2, paddingY: 1 }}>
			<Container onClick={scrollToItem} hasSection={hasSection}>
				<Grid container alignItems='center'>
					<Grid item>
						<StyledImage
							src={project.imgLink}
							alt='Festival Dust Icon'
							height={50}
							width={50}
						/>
					</Grid>
					<Grid item xs>
						<InfoColumn project={project} />
					</Grid>
					{hasSection && (
						<Grid item>
							<Chevron />
						</Grid>
					)}
				</Grid>
			</Container>
		</Grid>
	);
};

export default BrowseSectionBlock;
